import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { ValidarSolicitudDuplicadaRequest, ValidarSolicitudDuplicadaResponse } from '../../models/validar-solicitud-duplicada/validar-solicitud-duplicada';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root',
})
export class ValidarSolicitudDuplicadaService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.VALIDAR_SOLICITUD_DUPLICADA}`;

  constructor(private http: HttpClient) {}

  validarDuplicado(
    request: ValidarSolicitudDuplicadaRequest,
  ): Observable<ValidarSolicitudDuplicadaResponse> {
    return this.http.post<ValidarSolicitudDuplicadaResponse>(this.apiUrl, request);
  }
}
